const REDIRECT_STORAGE_KEY = 'SMART_SALES_SIDEBAR_BIND_REDIRECT'
export const SIDEBAR_BIND_ENTRY_PATH = '/smartSalesAi/sidebarBind'

function pathnameOf(path = '') {
  return String(path || '')
    .split('?')[0]
    .replace(/\/+$/, '')
}

export function isSidebarBindPath(path) {
  return pathnameOf(path) === SIDEBAR_BIND_ENTRY_PATH
}

export function rememberSidebarBindRedirect(fullPath = '') {
  const raw = String(fullPath || '').trim()
  if (!isSidebarBindPath(raw)) return ''
  const value = raw.startsWith('/') ? raw : `/${raw}`
  try {
    sessionStorage.setItem(REDIRECT_STORAGE_KEY, value)
  } catch (e) {
    // ignore
  }
  return value
}

export function consumeSidebarBindRedirect() {
  try {
    const cached = sessionStorage.getItem(REDIRECT_STORAGE_KEY)
    sessionStorage.removeItem(REDIRECT_STORAGE_KEY)
    return cached && isSidebarBindPath(cached) ? cached : ''
  } catch (e) {
    return ''
  }
}

export function parseSidebarBindLocation(fullPath = '') {
  const raw = String(fullPath || '').trim()
  const qIndex = raw.indexOf('?')
  const path = pathnameOf(qIndex >= 0 ? raw.slice(0, qIndex) : raw) || SIDEBAR_BIND_ENTRY_PATH
  const query = {}
  if (qIndex >= 0) {
    raw
      .slice(qIndex + 1)
      .split('&')
      .forEach(pair => {
        if (!pair) return
        const eq = pair.indexOf('=')
        const key = decodeURIComponent(eq >= 0 ? pair.slice(0, eq) : pair)
        const value = decodeURIComponent(eq >= 0 ? pair.slice(eq + 1) : '')
        if (key) query[key] = value
      })
  }
  return { path, query }
}

/** 登录页 redirect 未编码时，followUserId/tenantId 可能变成登录页自己的 query */
export function resolveSidebarBindRedirectFromRoute(route) {
  const redirect = route?.query?.redirect
  if (!isSidebarBindPath(redirect)) return ''
  const loc = parseSidebarBindLocation(redirect)
  ;['followUserId', 'tenantId'].forEach(key => {
    if (!loc.query[key] && route.query && route.query[key]) {
      loc.query[key] = String(route.query[key])
    }
  })
  const qs = Object.keys(loc.query)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(loc.query[key])}`)
    .join('&')
  return qs ? `${loc.path}?${qs}` : loc.path
}
